import { format as dateFnsFormat, isValid, parseISO } from 'date-fns';

export function formatDate(date: unknown, dateFormat: string) {
  const parsedDate = date instanceof Date ? date : parseISO(date as string);

  if (isValid(parsedDate)) {
    return dateFnsFormat(parsedDate, dateFormat);
  }
  return '';
}

export function getPlaceholderFromDateFormat(dateFormat: string, locale: 'fr' | 'en') {
  if (locale === 'en') {
    return dateFormat.toUpperCase();
  } else {
    return dateFormat.replace(/y/gi, 'A').replace(/d/gi, 'J').toUpperCase();
  }
}
